/**
 * Default width for a edge in the tree component.
 * Could be override with the custom width in the treeConfig {@link TreeConfig}.
 */
export const DEF_EDGE_WIDTH = 96;

/**
 * Default max width for a node in the tree component.
 * Could be override with the custom max width in the treeConfig {@link TreeConfig}.
 */
export const DEF_NODE_MAX_WIDTH = 670;

/**
 * Default offset for a edge in the tree component.
 * Could be override with the custom offset in the treeConfig {@link TreeConfig}.
 */
export const DEF_EDGE_OFFSET = 20;

/**
 * Default thickness for a edge in the tree component.
 * Could be override with the custom thickness in the edgeStyle {@link EdgeStyle}.
 */
export const DEF_EDGE_THICKNESS = 1;
